import styled, { css } from "styled-components";
import Link from "next/link";

export const List = styled.ul`
  ${({ theme: { breakpoints } }) => css`
    display: flex;
    padding: 0;
    margin: 0;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      display: none;
    }
  `}
`;

export const Item = styled.li`
  ${({ theme: { colors, breakpoints } }) => css`
    padding: 0 8px;
    position: relative;

    &:first-of-type {
      padding-left: 0;
    }

    &::after {
      position: absolute;
      right: 0;
      content: "|";
      color: ${colors.darkGray};
      font-size: 10px;
      top: 5px;
    }

    &:last-of-type {
      &::after {
        display: none;
      }
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      display: none;
    }
  `}
`;

export const CustomLink = styled(Link)`
  ${({ theme: { colors } }) => css`
    font-size: 11px;
    line-height: 1.5;
    color: ${colors.darkGray};
    transition: all 300ms ease-out;
    background-image: none;

    &:hover {
      color: ${colors.deepBlack};
    }
  `}
`;

export const ActiveBreadcrumb = styled.span`
  ${({ theme: { colors } }) => css`
    font-size: 11px;
    line-height: 1.5;
    color: ${colors.darkGray};
    transition: all 300ms ease-out;
    background-image: none;
    cursor: default;
  `}
`;